import { render, staticRenderFns } from "./Contactform.vue?vue&type=template&id=4fd2ab88&"
import script from "./Contactform.vue?vue&type=script&setup=true&lang=js&"
export * from "./Contactform.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports